import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Collapse rare list filter axes — plan/34+35 G.
 * Toggle sits inline on the primary filter row; expanded axes wrap below.
 */
export function AdminMoreFilters(props: {
  children: ReactNode;
  /** True when any nested filter is away from default (badge the toggle). */
  activeCount?: number;
  className?: string;
  label?: string;
}) {
  const [open, setOpen] = useState(() => (props.activeCount ?? 0) > 0);
  const label = props.label ?? "More filters";
  const count = props.activeCount ?? 0;
  return (
    <>
      <button
        type="button"
        className={cn(
          "inline-flex min-h-11 shrink-0 items-center gap-1.5 px-2 text-sm text-[var(--color-muted)] hover:text-[var(--color-foreground)]",
          props.className,
        )}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <ChevronDown
          className={cn(
            "size-3.5 transition-transform",
            open ? "rotate-0" : "-rotate-90",
          )}
          aria-hidden
        />
        {label}
        {count > 0 ? (
          <span className="rounded-full bg-[var(--color-primary)]/12 px-1.5 py-0.5 text-[10px] font-medium text-[var(--color-primary)]">
            {count}
          </span>
        ) : null}
      </button>
      {open ? (
        <div
          className="order-10 flex w-full basis-full flex-wrap items-center gap-[var(--desk-filter-gap)] border-t border-[var(--color-border)]/70 pt-2"
          role="group"
          aria-label={label}
        >
          {props.children}
        </div>
      ) : null}
    </>
  );
}
